module.exports = __webpack_public_path__ + "static/img/home.a082d79.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home.jpg
// module id = 0uWU
// module chunks = 1